/* global locale */

import Vue from 'vue/dist/vue.esm'
import VueI18n from 'vue-i18n'
Vue.use(VueI18n)
import VeeValidate, { Validator } from 'vee-validate'
import TurbolinksAdapter from 'vue-turbolinks'
Vue.use(TurbolinksAdapter)
import { messages } from 'default/translated_text'
import Vuex from 'vuex'
Vue.use(Vuex)

export default {
  loadVueComponent(component, element, store = null) {
    if (element == null) { return }

    Vue.use(VeeValidate, {events: 'blur'})
    Validator.localize(window.locale, messages[window.locale])
    const i18n = new VueI18n({ locale, messages, fallbackLocale: 'en' })

    return new Vue({
      store,
      i18n,
      render: h => h(component)
    }).$mount(element)
  }
}
